// usersReducer.js
const initialState = {
  isLoading: false,
  user: {},
  usersList: {},
  newUser: {},
  currentData: {},
  details: {},
  errors: null,
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_Users_req":
      return {
        ...state,
        isLoading: true,
      };
    case "get_Users_success":
      return {
        ...state,
        isLoading: false,
        usersList: action.payload,
      };
    case "get_Users_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "user_List_req":
      return {
        ...state,
        isLoading: true,
      };
    case "user_List_success":
      return {
        ...state,
        isLoading: false,
        user: action.payload,
      };
    case "user_List_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "user_req_delete":
      return {
        ...state,
        isLoading: true,
      };
    case "user_delete":
      return {
        ...state,
        isLoading: false,
        user: action.payload,
      };
    case "user_delete_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "add_user_req":
      return {
        ...state,
        isLoading: true,
      };
    case "add_user_success":
      return {
        ...state,
        isLoading: false,
        newUser: action.payload,
      };
    case "add_user_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "edit_user_req":
      return {
        ...state,
        isLoading: true,
      };
    case "edit_user_success":
      return {
        ...state,
        isLoading: false,
        newUser: action.payload,
      };
    case "edit_user_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "set_user_details":
      return {
        ...state,
        isLoading: false,
        currentData: action.payload,
      };
    case "reset_user_details":
      return {
        ...state,
        isLoading: false,
        currentData: {},
      };
    case "set_current_user_details":
      return {
        ...state,
        isLoading: false,
        currentData: action.payload,
      };
    case "set_booking_details":
      return {
        ...state,
        isLoading: false,
        bookingData: action.payload,
      };
    case "reset_facility_details":
      return {
        ...state,
        isLoading: false,
        currentData: {},
      };
    default:
      return state;
  }
};

export { usersReducer };
